import {Suspense} from "react";
import pagesExport from "./pages/exports";
import langExport from "./_lang/exports";
import seoExport from "./_seo/exports";
import settingsExport from "./_settings/exports";
import cmsExport from "./cms/exports";
import storageExport from "./storage/exports";
import publicExport from "./public/exports";
import textEditorExport from "../modules/textEditor/exports";
import designExport from "../modules/design/exports";
import categoriesExport from "./categories/exports";
import productsExport from "../modules/products/exports";


const modules = {
    pages: pagesExport, // PAGES BEFORE LANG (TO LOAD PAGES SLUGS)
    lang: langExport,
    seo: seoExport,
    settings: settingsExport,
    cms: cmsExport,
    storage: storageExport,
    public: publicExport,
    textEditor: textEditorExport,
    design: designExport,
    categories: categoriesExport,
    products: productsExport,
}


const defaultRoutes = {};
export const modulesRoutes = {};
export let modulesWrappers = [];
export let modulesPreloads = [];
const graphqls = {};
export const menus = {};
export const widgets = {};


for (let moduleKey in modules) { // prvi level, za Layout
    const module = modules[moduleKey];
    if (module.routes) {
        for (let i = 0; i < module.routes.length; i++) {
            const route = module.routes[i];
            if (route.name) {
                defaultRoutes[`${moduleKey}.${route.name}`] = {...route, name: `${moduleKey}.${route.name}`};
            }
        }
    }
    if (module.widgets) {
        for (let widgetKey in module.widgets) {
            widgets[`${moduleKey}.${widgetKey}`] = module.widgets[widgetKey];
        }
    }
    if (module.wrappers) {
        modulesWrappers = [...modulesWrappers, ...module.wrappers];
    }
    if (module.preloads) {
        modulesPreloads = [...modulesPreloads, ...module.preloads];
    }
    if (module.graphql) {
        for (let graphqlKey in module.graphql) {
            graphqls[`${moduleKey}.${graphqlKey}`] = module.graphql[graphqlKey];
        }
    }
}

export function addToRoutes(routes) {
    for (let routerKey in routes) {
        const route = routes[routerKey];
        if (route.layouts) {
            const holderPath = [];
            const holderLayouts = [];
            for (let j = 0; j < route.layouts.length; j++) {
                if (!defaultRoutes[route.layouts[j]]) {
                    console.log(`Ne postoji layout ${route.layouts[j]}`);
                    continue;
                }
                const layout = defaultRoutes[route.layouts[j]];
                holderLayouts.push(layout);
                if (typeof layout.path === "string") {
                    for (let k = 0; k < route.path.length; k++) {
                        if (route.path[k] === null) continue;
                        const append = (layout.path.startsWith("/") || layout.path === "") ? "" : "/";
                        const path = layout.path === "/" ? "" : layout.path;
                        holderPath[k] = (holderPath[k] || "") + append + path;
                    }
                } else {
                    for (let k = 0; k < route.path.length; k++) {
                        if (route.path[k] === null) continue;
                        const append = (layout.path[k].startsWith("/") || layout.path[k] === "") ? "" : "/";
                        const path = layout.path[k] === "/" ? "" : layout.path[k];
                        holderPath[k] = (holderPath[k] || "") + append + path;
                    }
                }
            }
            for (let k = 0; k < route.path.length; k++) {
                if (route.path[k] === null) continue;
                const append = (route.path[k].startsWith("/") || (route.path[k] === "" && holderPath[k] !== ""))
                    ? "" : "/";
                const path = route.path[k] === "/" ? "" : route.path[k];
                holderPath[k] = (holderPath[k] || "") + append + path;
            }
            modulesRoutes[routerKey] = {...route, fullpath: holderPath, layouts: holderLayouts};
        }
        if (route.menus) {
            for (let menuKey in route.menus) {
                if (!menus[menuKey]) menus[menuKey] = {};
                const pos = route.menus[menuKey].position || 100;
                if (!menus[menuKey][pos]) menus[menuKey][pos] = [];
                menus[menuKey][pos].push(modulesRoutes[routerKey]);
            }
        }
    }
}

addToRoutes(defaultRoutes);

export const graphql = (path, body, extend) => {
    if(!graphqls[path]) {
        console.log("MISSING: ", `Ne postoji graphql: ${path}`)
        return {fragment: "", body: ""};
    }
    let graph;
    if (typeof graphqls[path] === 'function') {
        graph = graphqls[path]();
    } else {
        graph = graphqls[path];
    }
    return {fragment: graph, body: `${body} { 
        ...${graph.definitions[graph.definitions.length-1].name.value} 
        ${extend ? extend : ""}
    }`};
}
export const widget = (path, params = false, suspense = true) => {
    if (!widgets[path]) {
        console.log("MISSING: ", `Ne postoji widget: ${path}`)
        return null;
    }
    const Element = widgets[path];
    const arr = path.split(".");
    if (arr[1][0] === arr[1][0].toUpperCase()) {
        if (!suspense) {
            return <Element {...params} />
        }
        return <Suspense fallback={<div />}>
            <Element {...params} />
        </Suspense>
    }
    if (params !== false) {
        return widgets[path](params);
    }
    return widgets[path];
}
export const module = (name) => {
    return modules[name];
}

